import { useDailyVisit } from '../hooks/useDailyVisit'
import { useRoomIsLoading } from '../hooks/useRoomIsLoading'
import { useCallSwitchingLoader } from '../hooks/useCallSwitchingLoader'
import { RoomLoadingSpinner } from './RoomLoadingSpinner'
import { VideoThumbnail } from './VideoThumbnail'
import { DailyFooter } from './DailyFooter'
import { RemotePatientMuteBadge } from './RemotePatientMuteBadge'

export function ForegroundLayer() {
  const { roomIsLoading } = useRoomIsLoading()
  const { is, not, isPhoneCall, isPrepMode, isInitiatingCall } = useDailyVisit()
  const { isSwitchingCall } = useCallSwitchingLoader(is('CALL_IS_ACTIVE'))
  const callInactive = not('CALL_IS_ACTIVE', 'PROVIDER_CONNECTED_AND_WAITING_FOR_PATIENT_CONNECTION')

  if ((roomIsLoading || isInitiatingCall || isSwitchingCall) && !isPrepMode) return <RoomLoadingSpinner contained />

  if (callInactive) return null

  return (
    <div className='absolute bottom-0 left-0 right-0 top-0 z-10 flex w-full flex-col'>
      <div className='relative flex-1'>
        {is('CALL_IS_ACTIVE') && !isPhoneCall && (
          <div className='absolute left-sp-2 top-sp-2'>
            <RemotePatientMuteBadge />
          </div>
        )}
        <div className='absolute right-0 top-sp-2 flex items-end justify-between px-sp-2'>
          {!isPhoneCall && <VideoThumbnail />}
        </div>
      </div>
      <div className='absolute bottom-0 z-20 flex w-full'>
        <DailyFooter />
      </div>
    </div>
  )
}
